import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=43444f5b&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43444f5b')) {
      api.createRecord('43444f5b', component.options)
    } else {
      api.reload('43444f5b', component.options)
    }
    module.hot.accept("./pricelist.vue?vue&type=template&id=43444f5b&", function () {
      api.rerender('43444f5b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22nZ4mBGEQlD7/JS/comp/pricelist.vue"
export default component.exports